/* eslint-disable  no-extra-boolean-cast */
import { FC, useState } from 'react';
import { getPasswordError, getReEnteredPasswordError } from 'utils';
import { Button, LearningPanelNotification } from 'common-components';
import { useTranslationContext } from '../../contexts/translationContext';
import Password from '../../password/password';
import { ArrowBack } from '../../uiLibraryImports';
import './resetPassword.scss';

const ResetPassword: FC<ResetPasswordProps> = (props: ResetPasswordProps) => {
    const { isLoading, resetPassword, generalError, onBackToLogin } = props;
    const { translate } = useTranslationContext();

    const [password, setPassword] = useState<string>('');
    const [reEnteredPassword, setReEnteredPassword] = useState<string>('');
    const [passwordError, setPasswordError] = useState<string>('');
    const [reEnteredPasswordError, setReEnteredPasswordError] = useState<string>('');

    const isEnabled = Boolean(password) && password === reEnteredPassword && !reEnteredPasswordError && !passwordError;

    const validatePassword = (): void => {
        if (!password) return setPasswordError('');

        return setPasswordError(getPasswordError(password));
    };

    const validateReEnteredPassword = (): void => {
        if (reEnteredPassword) return setReEnteredPasswordError(getReEnteredPasswordError(password, reEnteredPassword));
        return setReEnteredPasswordError('');
    };

    return (
        <div className="reset-password-wrapper">
            <div className="login-text">{translate('ResetPassword')}</div>
            <div className="inputs">
                <div className="section">
                    <div className="up-title">{translate('Password')}</div>
                    <Password
                        password={password}
                        onChangePassword={setPassword}
                        error={!!passwordError}
                        errorMessage={translate(passwordError)}
                        onBlur={validatePassword}
                    />
                </div>
                <div className="section">
                    <div className="up-title">{translate('ReEnterPassword')}</div>
                    <Password
                        password={reEnteredPassword}
                        onChangePassword={setReEnteredPassword}
                        error={!!reEnteredPasswordError}
                        errorMessage={translate(reEnteredPasswordError)}
                        onBlur={validateReEnteredPassword}
                    />
                </div>
                {generalError ? (
                    <div className="general-error-section">
                        <LearningPanelNotification
                            notificationText={generalError}
                            hasClose={false}
                            variant="error"
                            handleClose={() => undefined}
                        />
                    </div>
                ) : (
                    <div className="general-error-place-holder"></div>
                )}
            </div>
            <div className="buttons">
                <Button
                    type={isEnabled ? 'bigGradient' : 'bigGradientDisable'}
                    onClick={() => (isEnabled ? resetPassword(password) : undefined)}
                    text={translate('Reset password')}
                    isLoading={isLoading}
                    lowerCase
                />
            </div>
            <div className="back-to-login" onClick={() => onBackToLogin()}>
                <ArrowBack className="arrow-back" />
                <div data-testid="text">{translate('BackToLogin')}</div>
            </div>
        </div>
    );
};

interface ResetPasswordProps {
    resetPassword: Function;
    onBackToLogin: Function;
    isLoading?: boolean;
    generalError?: string;
}

export default ResetPassword;
